import React from "react";

import { Container, Typography } from "@material-ui/core";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import { styles } from "./PageBanner.styles";

interface PageBannerProps extends WithStyles<typeof styles> {
    title: string;
    isPublic?: boolean;
}

const PageBannerPure: React.FunctionComponent<PageBannerProps> = ({classes, title, isPublic}) => {
    return <div className={`${classes.header} ${isPublic ? classes.public : classes.account}`}>
        <Container>
            <Typography variant="h1">{title}</Typography>
        </Container>
    </div>;
};

export const PageBanner = withStyles(styles)(PageBannerPure);
